<div class="section">
  <h3 class="title"><b>Ansprechpartner:in Daten bearbeiten</b></h3>
  <div class="container">
    <div style="display: flex; gap: 16px">
      <app-select
        style="display: block; width: 150px"
        label="Anrede"
        [options]="genderOptions"
        [control]="formGroup.controls.gender"
        [errorMessages]="{
          required: 'errors.required' | translate
        }"></app-select>
      <app-text-field
        label="Vorname"
        appearance="outline"
        [inputProps]="{
          maxlength: '8'
        }"
        [inputControl]="formGroup.controls.firstName"
        [errorMessages]="{
          required: 'errors.required' | translate
        }" />
    </div>
    <app-text-field
      label="Nachname"
      appearance="outline"
      [inputProps]="{
        maxlength: '70'
      }"
      [inputControl]="formGroup.controls.lastName"
      [errorMessages]="{
        required: 'errors.required' | translate
      }" />
    <app-select
      label="Position"
      [options]="positionOptions"
      [control]="formGroup.controls.positionInFacility"
      [errorMessages]="{
        required: 'errors.required' | translate
      }"></app-select>
    <app-text-field
      label="E-Mail Adresse"
      appearance="outline"
      [inputProps]="{
        maxlength: '70'
      }"
      [inputControl]="formGroup.controls.email"
      [errorMessages]="{
        required: 'errors.required' | translate
      }" />
    <app-text-field
      label="Telefonnummer"
      appearance="outline"
      [inputControl]="formGroup.controls.phone"
      [inputProps]="{
        maxlength: '70'
      }"
      [errorMessages]="{
        pattern: 'errors.invalidPhoneNumber' | translate,
        required: 'errors.required' | translate
      }" />
  </div>
</div>
